import React, { useState } from 'react';
import QRCode from 'qrcode.react';
import axiosInstance from '../../axiosConfig';
import Notification from '../notification/Notification'; // Import the Notification component
import '../../styles/USDTWalletPayment.css';

const USDTWalletPayment = ({ onPaymentSuccess, amount }) => {
    const [network, setNetwork] = useState('ERC20');
    const [transactionHash, setTransactionHash] = useState('');
    const [paymentStatus, setPaymentStatus] = useState('');
    const [notification, setNotification] = useState(null);
    const [copySuccess, setCopySuccess] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const walletAddresses = {
        ERC20: process.env.REACT_APP_ERC20_USDT_WALLET_ADDRESS || '0x5F5C851F9EECb33bE40e443f4c6fF4E4dFd90dfA', // Fallback for testing
        TRC20: process.env.REACT_APP_TRC20_USDT_WALLET_ADDRESS || 'TSsFxiQGPz8j4cYXk4PfQMPfrwEr5N9AcD', // Fallback for testing
    };

    const handleNetworkChange = (e) => {
        setNetwork(e.target.value);
    };

    const handleTransactionHashChange = (e) => {
        setTransactionHash(e.target.value);
    };

    const handlePaymentSubmit = async () => {
        // Reset notification and payment status before submission
      //  setNotification({ message: '', isError: false });
        setPaymentStatus('');
        
        if (!transactionHash) {
            setNotification({ message: 'Transaction hash is required.', isError: true });
            return;
        }

        setIsLoading(true);
        try {
            const response = await axiosInstance.post('/api/usdt/execute/execute-usdt', { 
                transactionHash, 
                network 
            });

            if (response.data.status === 'COMPLETED') {
                setPaymentStatus('Payment confirmed!');
                setNotification({ message: 'Payment confirmed!', isError: false });
                onPaymentSuccess();
                setTransactionHash(''); // Clear the transaction hash input
            } else {
                setPaymentStatus('Payment verification failed.');
                setNotification({ message: 'Payment verification failed.', isError: true });
            }
        } catch (error) {
            // setPaymentStatus('Error verifying payment.');
            setNotification({ message: 'Error verifying payment.', isError: true });
           // console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text)
            .then(() => {
                setCopySuccess('Copied!');
                setNotification({ message: 'Address copied to clipboard!', isError: false });
                setTimeout(() => setCopySuccess(''), 2000); // Clear the message after 2 seconds
            })
            .catch(err => {
                setNotification({ message: 'Failed to copy address.', isError: true });
              //  console.error('Failed to copy: ', err);
            });
    };

    return (
        <div className="usdt-payment-container">
            <h2>Pay with USDT</h2>
            <div className="network-selection">
                <label>Select Network:</label>
                <select value={network} onChange={handleNetworkChange}>
                    <option value="ERC20">Ethereum (ERC20)</option>
                    <option value="TRC20">Tron (TRC20)</option>
                </select>
            </div>
            <div className="address-section">
                <label>Send USDT to the following address:</label>
                <div className="address-container">
                    <span className="wallet-address">{walletAddresses[network]}</span>
                    <button className="copy-button" onClick={() => copyToClipboard(walletAddresses[network])}>Copy</button>
                    {copySuccess && <span className="copy-success">{copySuccess}</span>}
                </div>
                <div className="qrcode-container">
                    <QRCode value={walletAddresses[network]} />
                </div>
            </div>
            <div className="amount-section">
                <label>Amount to send:</label>
                <div>{amount} USDT</div>
            </div>
            <div className="transaction-hash-section">
                <label>Transaction Hash:</label>
                <input
                    type="text"
                    value={transactionHash}
                    onChange={handleTransactionHashChange}
                    placeholder="Enter the transaction hash from your wallet"
                />
            </div>
            <div className="instructions">
                <small>After sending {amount} USDT, copy the transaction hash from your wallet's transaction history and paste it here.</small>
            </div>
            <button className="submit-button" onClick={handlePaymentSubmit} disabled={isLoading}>
                {isLoading ? 'Submitting...' : 'Submit Payment'}
            </button>
            {paymentStatus && <div className={`payment-status ${paymentStatus === 'Payment confirmed!' ? 'success' : 'error'}`}>{paymentStatus}</div>}
            {notification&& (
                <Notification
                    message={notification.message}
                    isError={notification.isError}
                    onClose={() => setNotification(null)}
                />
            )}
        </div>
    );
};

export default USDTWalletPayment;
